<template>
  <div class="ms-container">
    <row :gutter="16">
      <i-col span="8">
        <contract-info
          ref="commonInfo"
          @update="updateChildren('commonInfo')"
        />
        <contract-subinfo ref="subInfo" style="margin-top: 16px" />
        <contract-documents style="margin-top: 16px" />
      </i-col>
      <i-col span="16">
        <contract-stats
          ref="stats"
          @update="updateChildren('stats')"
          :style="hasAmendments ? 'margin-top: 19px' : 'margin-top: 0px;'"
        />
        <contract-roadmap
          ref="roadmap"
          @update="updateChildren('roadmap')"
          style="margin-top: 16px"
        />
      </i-col>
    </row>
  </div>
</template>

<script>
import ContractInfo from '@/components/contract/overview/contract-info'
import ContractRoadmap from '@/components/contract/overview/contract-roadmap'
import ContractSubinfo from '@/components/contract/overview/contract-subinfo'
import ContractStats from '@/components/contract/overview/contract-stats'
import ContractDocuments from '@/components/contract/overview/contract-documents'

export default {
  components: {
    ContractInfo,
    ContractRoadmap,
    ContractSubinfo,
    ContractStats,
    ContractDocuments
  },
  computed: {
    hasAmendments () {
      const { current } = this.$store.state.contracts

      if (!current) return false

      return current.amendments && !!current.amendments.length
    }
  },
  watch: {
    '$route.params.id': function () {
      this.changeContract()
    }
  },
  methods: {
    updateChildren (source) {
      const children = ['commonInfo', 'stats', 'roadmap', 'subInfo']

      children
        .filter((ch) => ch !== source)
        .forEach((name) => this.$refs[name].getData())
    },
    changeContract () {
      const children = ['commonInfo', 'subInfo', 'stats', 'roadmap']
      children.forEach((name) => this.$refs[name].getData())
    }
  }
}
</script>

<style>
</style>
